import { trimHTML } from '@/utils/editor'

/**
 * 将待发送的文本消息进行处理
 *  1. 将 br 替换为 \n
 *  2. 将表情包替换为相应的 code
 * @param { String } html
 * @returns { String }
 */
export default function html2Str (html) {
    html = trimHTML(html) // 过滤前后换行或空格

    return html
        .replace(/<br>{1,2}/g, '\n')
        .replace(/<img[^<]+code="([^"]+)"[^>]*>/gi, '$1')
        .replace(/<\/?div>/gi, '') // Fix：ios机型在换行时可能出现自动添加div标签的情况
}
